import api from '../collums-components/api/config';

class MembershipsApi {
    static listMemberships(qs) {
        return api.request({
            method: 'GET',
            url: `/membership${qs}`
        });
    }

    static getMembershipsByCategory() {
        return api.request({
            method: 'GET',
            url: '/membership/groupedByCategory'
        });
    }

    static getMembershipWithoutAppt(id) {
        return api.request({
            method: 'GET',
            url: `/membership/withoutAppt/${id}`
        });
    }

    static archiveMembership(id, value, isFromOrg = false, clinic) {
        return api.request({
            method: 'PUT',
            url: `/membership/archive/${id}?value=${value}&isFromOrg=${isFromOrg}&clinic=${clinic}`
        });
    }

    static activeMembership(id) {
        return api.request({
            method: 'PUT',
            url: `/membership/active/${id}`
        });
    }

    static createMembership(body) {
        return api.request({
            method: 'POST',
            url: '/membership',
            data: body
        });
    }

    static updateMembership(id, body, isFromOrg = false, clinic) {
        return api.request({
            method: 'PUT',
            url: `/membership/${id}?isFromOrg=${isFromOrg}&clinic=${clinic}`,
            data: body
        });
    }

    static deleteMembership(id) {
        return api.request({
            method: 'DELETE',
            url: `/membership/${id}`
        });
    }

    static changeMembershipActive(id, value, isFromOrg = false, clinic) {
        return api.request({
            method: 'PUT',
            url: `/membership/${id}/change-active?value=${value}&isFromOrg=${isFromOrg}&clinic=${clinic}`
        });
    }

    static changeMembershipShowOnline(id, clinic, isFromOrg = false, value) {
        return api.request({
            method: 'PUT',
            url: `/membership/${id}/change-show-online?isFromOrg=${isFromOrg}&clinic=${clinic}&value=${value}`
        });
    }
}

export default MembershipsApi;
